import React from 'react';
import './style.scss';
import { useTranslation } from 'react-i18next';

interface PageTitleProps {
  pageNumber: number;
}

const PdfPageTitle: React.FC<PageTitleProps> = ({ pageNumber }) => {
  const { t } = useTranslation();
  return (
    <div className="pdf-list-header">
      <span className="pdf-list-title">
        {pageNumber} - {t(`pdf:pageTitles.${pageNumber}`)}
      </span>
    </div>
  );
};

export default PdfPageTitle;
